import { useEffect, useState } from 'react';
import {
  getCountries,
  getLpSuppliers,
  getMarkets,
  getShips,
} from '../../master-data';
import { getShipments } from '../services/VoyageRepository';

const useFetchData = (row, { includeShipments = false } = {}) => {
  const [countries, setCountries] = useState([]);
  const [shippingCompanies, setShippingCompanies] = useState([]);
  const [portOperator, setPortOperator] = useState([]);
  const [shipmentDetails, setShipmentDetails] = useState([]);
  const stock = [];
  const [markets, setMarkets] = useState([]);
  const [ships, setShips] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setIsLoaded(false);

    const fetchCountries = async () => {
      try {
        const countriesData = await getCountries();
        if (!cancelled) setCountries(countriesData);
      } catch (error) {
        console.error('Error fetching countries:', error);
      }
    };

    const fetchSupplier = async () => {
      try {
        const supplierData = await getLpSuppliers({ isShippingCompany: true });
        if (!cancelled) setShippingCompanies(supplierData);
      } catch (error) {
        console.error('Error fetching Supplier:', error);
      }
    };

    const fetchPortOperator = async () => {
      try {
        const portOperatorData = await getLpSuppliers({ isPortOperator: true });
        if (!cancelled) setPortOperator(portOperatorData);
      } catch (error) {
        console.error('Error fetching Port Operator', error);
      }
    };

    const fetchShipmentDetails = async () => {
      try {
        const shipmentDetailsData = await getShipments();
        if (!cancelled) setShipmentDetails(shipmentDetailsData);
      } catch (error) {
        console.error('Error fetching Shipment Data:', error);
      }
    };

    const fetchMarket = async () => {
      try {
        const marketData = await getMarkets();
        if (!cancelled) setMarkets(marketData);
      } catch (error) {
        console.error('Error fetching Market Data:', error);
      }
    };

    const fetchShips = async () => {
      try {
        const shipsData = await getShips();
        if (!cancelled) setShips(shipsData);
      } catch (error) {
        console.error('Error fetching Ships Data:', error);
      }
    };

    const fetches = [
      fetchCountries(),
      fetchSupplier(),
      fetchPortOperator(),
      fetchMarket(),
      fetchShips(),
    ];
    if (includeShipments) {
      fetches.push(fetchShipmentDetails());
    }

    Promise.all(fetches).finally(() => {
      if (!cancelled) setIsLoaded(true);
    });

    return () => {
      cancelled = true;
    };
  }, [row, includeShipments]);

  return {
    countries,
    shippingCompanies,
    portOperator,
    shipmentDetails,
    stock, // no data fetching implemented for stock yet
    markets,
    ships,
    isLoaded,
  };
};

export default useFetchData;
